import React from 'react'

export default props => (
  <svg
    width="13"
    height="6"
    viewBox="0 0 13 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.539062 1.35847C0.539062 0.9337 0.883407 0.589355 1.30818 0.589355H11.0712C11.496 0.589355 11.8404 0.933701 11.8404 1.35847V4.43493C11.8404 4.8597 11.496 5.20405 11.0712 5.20405H1.30818C0.883407 5.20405 0.539062 4.8597 0.539062 4.43493V1.35847ZM12.0918 3.74674V2.04659H12.3325C12.6157 2.04659 12.8452 2.27616 12.8452 2.55934V3.234C12.8452 3.51718 12.6157 3.74674 12.3325 3.74674H12.0918ZM1.30217 0.832208C1.01899 0.832208 0.789426 1.06177 0.789426 1.34495V4.4484C0.789426 4.73158 1.01899 4.96114 1.30217 4.96114H11.0757C11.3589 4.96114 11.5884 4.73158 11.5884 4.4484V1.34495C11.5884 1.06177 11.3589 0.832208 11.0757 0.832208H1.30217ZM1.04179 1.33143C1.04179 1.18984 1.15657 1.07506 1.29816 1.07506H11.0821C11.2237 1.07506 11.3385 1.18984 11.3385 1.33143V4.46187C11.3385 4.60346 11.2237 4.71824 11.0821 4.71824H1.29816C1.15657 4.71824 1.04179 4.60346 1.04179 4.46187V1.33143Z"
      fill="white"
    />
  </svg>
)
